import React, { useState, useEffect, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const EnvironmentContext = createContext(null);

// declare provider component
const EnvironmentProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [userModules, setUserModules] = useState(null);
  const [shouldUpdateModules, setShouldUpdateModules] = useState(false);
  const [shouldUpdateCheckInSurvey, setShouldUpdateCheckInSurvey] = useState(false);
  const [selectedMonitoredIndividual, setSelectedMonitoredIndividual] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedImpersonationUser, setSelectedImpersonationUser] = useState(null);
  const [activeUser, setActiveUser] = useState(null);
  const [reportsEnabled, setReportsEnabled] = useState(null);
  const [hasToken, setHasToken] = useState(false);
  const [checkinSurvey, setCheckinSurvey] = useState(null);


  const [selectedImpersonationUserEmail, setSelectedImpersonationUserEmail] = useState(null);
  const [reloadingFromJSON, setReloadingFromJSON] = useState(false);

  useEffect(() => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext onMount'); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  const storeContext = (overrideImpersonationUser, impersonationUser, overrideImpersonationUserEmail, impersonationUserEmail) => {

    let newSelectedImpersonationUserEmail = overrideImpersonationUserEmail ? impersonationUserEmail : selectedImpersonationUserEmail;
    let newSelectedImpersonationUser = overrideImpersonationUser ? impersonationUser : selectedImpersonationUser;
    const currentState = {
      user,
      organization,
      userModules,
      selectedMonitoredIndividual,
      selectedUnit,
      selectedImpersonationUser: newSelectedImpersonationUser,
      selectedImpersonationUserEmail: newSelectedImpersonationUserEmail,
      activeUser,
      unloadTime: Date.now(),
      reportsEnabled,
      checkinSurvey

    };

    sessionStorage.setItem('previousEnvironmentContext', JSON.stringify(currentState));
  }

  const handleUnload = () => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext handleUnload'); }
    storeContext(false, null, false, null);
  }

  const setStateFromObject = (updateObject) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setStateFromObject'); }

    if (updateObject.hasOwnProperty('user')) {

      if (!(JSON.stringify(user) === JSON.stringify(updateObject.user)))
      setUser(updateObject.user ? { ...updateObject.user } : null);
    }

    if (updateObject.hasOwnProperty('organization')) {
      if (!(JSON.stringify(organization) === JSON.stringify(updateObject.organization)))
      setOrganization(updateObject.organization ? { ...updateObject.organization } : null);
    }

    if (updateObject.hasOwnProperty('userModules')) {
      if (!(JSON.stringify(userModules) === JSON.stringify(updateObject.userModules)))
        setUserModules(updateObject.userModules ? [...updateObject.userModules] : null);
    }

    if (updateObject.hasOwnProperty('selectedMonitoredIndividual')) {
      if (!(JSON.stringify(selectedMonitoredIndividual) === JSON.stringify(updateObject.selectedMonitoredIndividual)))
      setSelectedMonitoredIndividual(updateObject.selectedMonitoredIndividual ? { ...updateObject.selectedMonitoredIndividual } : null);
    }

    if (updateObject.hasOwnProperty('selectedUnit')) {
      if (!(JSON.stringify(selectedUnit) === JSON.stringify(updateObject.selectedUnit)))
      setSelectedUnit(updateObject.selectedUnit ? { ...updateObject.selectedUnit } : null);
    }

    if (updateObject.hasOwnProperty('selectedImpersonationUser')) {
      if (!(JSON.stringify(selectedImpersonationUser) === JSON.stringify(updateObject.selectedImpersonationUser)))
      setSelectedImpersonationUser(updateObject.selectedImpersonationUser ? { ...updateObject.selectedImpersonationUser } : null);
    }

    if (updateObject.hasOwnProperty('selectedImpersonationUserEmail')) {
      if (selectedImpersonationUserEmail != updateObject.selectedImpersonationUserEmail)
        setSelectedImpersonationUserEmail(updateObject.selectedImpersonationUserEmail ? updateObject.selectedImpersonationUserEmail : null);
    }

    if (updateObject.hasOwnProperty('reportsEnabled')) {
      if (reportsEnabled != updateObject.reportsEnabled)
      setReportsEnabled(updateObject.reportsEnabled);
    }

    if (updateObject.hasOwnProperty('activeUser')) {
      if (!(JSON.stringify(activeUser) === JSON.stringify(updateObject.activeUser)))

      setActiveUser(updateObject.activeUser ? { ...updateObject.activeUser } : null);
    }

    if (updateObject.hasOwnProperty('shouldUpdateModules')) {
      if (shouldUpdateModules != updateObject.shouldUpdateModules)
        setShouldUpdateModules(updateObject.shouldUpdateModules);
    }

    if (updateObject.hasOwnProperty('shouldUpdateCheckInSurvey')) {
      if (shouldUpdateCheckInSurvey != updateObject.shouldUpdateCheckInSurvey)
        setShouldUpdateCheckInSurvey(updateObject.shouldUpdateCheckInSurvey);
    }

    if (updateObject.hasOwnProperty('hasToken')) {
      if (hasToken != updateObject.hasToken)
        setHasToken(updateObject.hasToken);
    }

    if (updateObject.hasOwnProperty('checkinSurvey')) {

      if (!(JSON.stringify(checkinSurvey) === JSON.stringify(updateObject.checkinSurvey)))
        setCheckinSurvey(updateObject.checkinSurvey ? { ...updateObject.checkinSurvey } : null);
    }


  }

  const reloadFromJSON = () => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext reloadFromJSON'); }
    setReloadingFromJSON(true)
    const previousEnvironmentContext = JSON.parse(sessionStorage.getItem('previousEnvironmentContext'));
    setStateFromObject(previousEnvironmentContext);
    setReloadingFromJSON(false)
  }

  const setTheHasToken = (hasToken) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheHasToken'); }
    let newHasToken = hasToken;
    setHasToken(newHasToken);
  }

  const setTheUser = (user) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheUser'); }
    setUser(user ? { ...user } : null);

    if (!selectedImpersonationUser) {
      setActiveUser(user ? { ...user } : null);
    }
  }

  const setTheCheckInSurvey = (checkinSurvey) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheCheckInSurvey'); }
    setCheckinSurvey(checkinSurvey ? { ...checkinSurvey } : null);
    setShouldUpdateCheckInSurvey(false);

  }

  const clearOrganization = (organization) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext clearOrganization'); }
    setOrganization(organization ? { ...organization } : null);
  }

  const setTheOrganization = (organization) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheOrganization'); }
    setOrganization(organization ? { ...organization } : null);
  }

  const clearUserModules = () => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext clearUserModules'); }
    setUserModules(null);
    setReportsEnabled(false);
  }

  const setTheUserModules = (modules) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheUserModules'); }
    setUserModules([...modules]);
    setShouldUpdateModules(false);
    setReportsEnabled(modules.filter(userModule => (userModule.name === "Reports")).length > 0 ? true : false)
  }

  const setTheSelectedMonitoredIndividual = (monitoredIndividual) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheSelectedMonitoredIndividual'); }
    setSelectedMonitoredIndividual(monitoredIndividual ? { ...monitoredIndividual } : null);
  }

  const setTheSelectedUnit = (unit) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheSelectedUnit'); }
    setSelectedUnit(unit ? { ...unit } : null);
  }

  const clearSelectedMonitoredIndividual = () => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext clearSelectedMonitoredIndividual'); }
    setSelectedMonitoredIndividual(null);
  }

  const clearSelectedUnit = () => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext clearSelectedUnit'); }
    setSelectedUnit(null);
  }

  const setTheShouldUpdateModules = (value) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheShouldUpdateModules'); }
    setShouldUpdateModules(!!value);
  }

  const setTheShouldUpdateCheckInSurvey = (value) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheShouldUpdateCheckInSurvey'); }
    setShouldUpdateCheckInSurvey(!!value);
  }

  const update = (updateObject) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext update'); }

    setStateFromObject(updateObject);

    if (updateObject.hasOwnProperty('selectedImpersonationUser')) {
      setActiveUser(updateObject.selectedImpersonationUser ? { ...updateObject.selectedImpersonationUser } : null);
    }

    if (updateObject.hasOwnProperty('userModules')) {
      let modules = updateObject.userModules;
      let reportsEnabledUpdate = false;
      if (modules && modules.length > 0) {
        reportsEnabledUpdate = modules.filter(userModule => (userModule.name === "Reports")).length > 0 ? true : false;
      }
      setReportsEnabled(reportsEnabledUpdate);
    }

    if (updateObject.hasOwnProperty('user')) {
      if (!selectedImpersonationUser) {
        setActiveUser(updateObject.user ? { ...updateObject.user } : null);
      }
    }
  }

  const setTheSelectedImpersonationUser = (impersonationUser) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheSelectedImpersonationUser'); }
    setActiveUser({ ...impersonationUser });
    setSelectedImpersonationUser({ ...impersonationUser });

    storeContext(true, null, false, null);
  }

  const clearSelectedImpersonationUser = () => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext clearSelectedImpersonationUser'); }

    storeContext(true, null, true, null);
    setActiveUser({ ...user });
    setSelectedImpersonationUserEmail(null);
    setSelectedImpersonationUser(null);
    setShouldUpdateModules(true);
    setShouldUpdateCheckInSurvey(true);
  }

  const setTheSelectedImpersonationUserEmail = (impersonationUserEmail) => {
    if (logComponent('EnvironmentContext')) { console.debug('EnvironmentContext setTheSelectedImpersonationUserEmail'); }
    setSelectedImpersonationUserEmail(impersonationUserEmail);
    setShouldUpdateCheckInSurvey(true);

    storeContext(false, null, true, impersonationUserEmail);
  }

  const environmentState = useMemo(() => ({
    user,
    organization,
    userModules,
    selectedMonitoredIndividual,
    selectedUnit,
    shouldUpdateModules,
    shouldUpdateCheckInSurvey,
    reportsEnabled,
    activeUser,
    hasToken,
    checkinSurvey,
    selectedImpersonationUser: selectedImpersonationUser,
    selectedImpersonationUserEmail: selectedImpersonationUserEmail,
    setUser: setTheUser,
    setOrganization: setTheOrganization,
    setUserModules: setTheUserModules,
    clearUserModules: clearUserModules,
    setSelectedMonitoredIndividual: setTheSelectedMonitoredIndividual,
    clearSelectedMonitoredIndividual: clearSelectedMonitoredIndividual,
    setSelectedUnit: setTheSelectedUnit,
    clearSelectedUnit: clearSelectedUnit,
    setShouldUpdateModules: setTheShouldUpdateModules,
    setShouldUpdateCheckInSurvey: setTheShouldUpdateCheckInSurvey,
    update: update,
    setSelectedImpersonationUser: setTheSelectedImpersonationUser,
    clearSelectedImpersonationUser: clearSelectedImpersonationUser,
    setSelectedImpersonationUserEmail: setTheSelectedImpersonationUserEmail,
    reloadFromJSON: reloadFromJSON,
    setHasToken: setTheHasToken,
    setCheckinSurvey: setTheCheckInSurvey
  }), [user,
    organization,
    userModules,
    selectedMonitoredIndividual,
    selectedUnit,
    shouldUpdateModules,
    shouldUpdateCheckInSurvey,
    reportsEnabled,
    activeUser,
    hasToken,
    checkinSurvey

  ]);

  return (
    <EnvironmentContext.Provider value={environmentState}>
      {children}
    </EnvironmentContext.Provider>
  );
}

// export provider and context
export { EnvironmentContext, EnvironmentProvider };